module.exports = __webpack_public_path__ + "static/img/22.c37e1c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/22.png
// module id = dHtA
// module chunks = 1